<template>
    <div>
        <Header />
        <MonthlyRanking />
        <div v-if="$store.state.hostName !== 'Q'">
            <Footer />
        </div>
    </div>
</template>

<script>
import Header from '@/components/Header.vue'
import MonthlyRanking from '@/components/MonthlyRanking.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'MonthlyRankingView',

  components: {
    Header,
    MonthlyRanking,
    Footer
  }
}
</script>
